import SellerNavbar from "../../components/sellers/SellerNavbar";
import SellerLoginForm from "../../components/sellers/SellerLoginForm";
import SellerFooter from "../../components/sellers/SellerFooter";

export default function SellerLoginPage() {
  return (
    <>
      <SellerNavbar />
      <SellerLoginForm />
      <SellerFooter />
    </>
  )
}

